import React from "react";

const VectorLand = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width="100%"
            height="100%"
            viewBox="0 0 1440 320"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            {...props}
        >
            {/* Land 1: Left */}
            <path
                d="M0 320 Q200 250 400 320 L0 320Z"
                fill="#4a2511"
                opacity="0.8"
            />
            {/* Land 2: Center */}
            <path
                d="M300 320 Q650 230 950 320 L300 320Z"
                fill="#3E2723"
            />
            {/* Land 3: Right */}
            <path
                d="M800 320 Q1150 260 1440 320 L800 320Z"
                fill="#4a2511"
                opacity="0.9"
            />
        </svg>
    );
};

export default VectorLand;
